import React from "react";
import { siteData } from "../mock";
import { MapPin } from "lucide-react";

export default function Zones() {
  const doubled = [...siteData.zones, ...siteData.zones];
  return (
    <section className="py-16 border-y border-[#e8e0d5] bg-[#fbf8f4] overflow-hidden">
      <div className="container-tight mb-8 flex items-center gap-3">
        <MapPin size={18} className="text-[#d97757]" />
        <span className="text-sm text-[#4a4642] uppercase tracking-[0.15em] font-medium">Zones d'intervention</span>
      </div>
      <div className="marquee-track">
        {doubled.map((z, i) => (
          <span
            key={i}
            className="font-serif text-3xl md:text-4xl text-[#1a1815] px-8 whitespace-nowrap flex items-center"
          >
            {z} <span className="text-[#d97757] mx-6">•</span>
          </span>
        ))}
      </div>
    </section>
  );
}
